import { render, staticRenderFns } from "./ReceiveAwardModal.vue?vue&type=template&id=97a1ee08&scoped=true&"
import script from "./ReceiveAwardModal.vue?vue&type=script&lang=js&"
export * from "./ReceiveAwardModal.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveAwardModal.vue?vue&type=style&index=0&id=97a1ee08&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a1ee08",
  null
  
)

export default component.exports